import { create } from 'zustand'

interface SupportUnreadState {
  unreadThreads: number
  unreadMessages: number
  setUnread: (threads: number, messages: number) => void
  reset: () => void
}

export const useSupportUnreadStore = create<SupportUnreadState>((set) => ({
  unreadThreads: 0,
  unreadMessages: 0,
  setUnread: (threads, messages) =>
    set({
      unreadThreads: Math.max(0, threads),
      unreadMessages: Math.max(0, messages),
    }),
  reset: () => set({ unreadThreads: 0, unreadMessages: 0 }),
}))
